import { render, staticRenderFns } from "./WhitelabelLanding.vue?vue&type=template&id=35710cbc&scoped=true&"
import script from "./WhitelabelLanding.vue?vue&type=script&lang=js&"
export * from "./WhitelabelLanding.vue?vue&type=script&lang=js&"
import style0 from "./WhitelabelLanding.vue?vue&type=style&index=0&id=35710cbc&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35710cbc",
  null
  
)

export default component.exports